import React from 'react';

import Swiper from '@travel/traveler-core/components/Swiper';
import { useDeviceType, MOBILE_SCREEN, TABLET_SCREEN } from '@travel/traveler-core/hooks';
import { GalleryIcon } from '@travel/ui';
import { GalleryMedia } from '@travel/ui/components/Gallery';
import { cx } from '@travel/utils';

import Media from 'components/Media';

import styles from './roomPlanGalleryCover.module.scss';

type Props = {
  medias: Array<GalleryMedia>;
  onOpenGallery: (index: number) => void;
  onOpenDetail: () => void;
  /** is first */
  isFirst: boolean;
};

function RoomPlanGalleryCover(props: Props) {
  const { medias, onOpenGallery, onOpenDetail, isFirst } = props;

  const deviceType = useDeviceType();

  const isMobile = deviceType === MOBILE_SCREEN;
  const isTablet = deviceType === TABLET_SCREEN;

  const handleOpenGallery = (index: number) => () => {
    onOpenGallery(index);
  };

  const handleClickGalleryIcon = () => {
    onOpenGallery(0);
  };

  return isMobile ? (
    <div className={styles.swiperWrapper}>
      <Swiper
        className={styles.swiper}
        paginationType="swipe"
        shouldUpdateOnceVisible={true}
        shouldNotSwipe={false}
        shouldRenderAllChild={false}
      >
        {medias.map((media, i) => (
          <Media
            className={styles.swiperMedia}
            key={`${media.url}${i}`}
            media={media}
            sizes="100vw"
            onClick={onOpenDetail}
            isDisableLazyload={isFirst && i === 0}
          />
        ))}
      </Swiper>
      <GalleryIcon
        iconSize={16}
        photosCount={medias.length}
        className={styles.galleryIcon}
        onClick={onOpenDetail}
      />
    </div>
  ) : medias.length >= 3 ? (
    <div className={styles.mediaGroupContainer}>
      <div className={styles.mainMediaWrapper}>
        <Media
          className={styles.zoomMedia}
          wrapperClassName={styles.mediaWrapper}
          key={`${medias[0].url}`}
          media={medias[0]}
          sizes="100vw"
          onClick={handleOpenGallery(0)}
        />
        <GalleryIcon
          iconSize={16}
          photosCount={medias.length}
          className={styles.galleryIcon}
          onClick={handleClickGalleryIcon}
        />
      </div>

      <Media
        className={styles.zoomMedia}
        wrapperClassName={cx(styles.mediaWrapper, styles.subMediaWrapper)}
        key={`${medias[1].url}`}
        media={medias[1]}
        sizes="100vw"
        onClick={handleOpenGallery(1)}
      />
      <Media
        className={styles.zoomMedia}
        wrapperClassName={cx(styles.mediaWrapper, styles.subMediaWrapper)}
        key={`${medias[2].url}`}
        media={medias[2]}
        sizes="100vw"
        onClick={handleOpenGallery(2)}
      />
    </div>
  ) : (
    <div className={styles.singleMediaWrapper}>
      <Media
        className={cx(styles.singleMedia, styles.zoomMedia)}
        wrapperClassName={!isTablet ? styles.mediaWrapper : undefined}
        key={`${medias[0].url}`}
        media={medias[0]}
        sizes="100vw"
        onClick={handleOpenGallery(0)}
      />
      {medias.length > 1 && (
        <GalleryIcon
          iconSize={16}
          photosCount={medias.length}
          className={styles.galleryIcon}
          onClick={handleClickGalleryIcon}
        />
      )}
    </div>
  );
}

export default RoomPlanGalleryCover;
